import React, { useState } from 'react';
import { FiCamera } from 'react-icons/fi';
import BridgeRequestModal from './BridgeRequestModal';

export default function BotonFotoRemota({ onFoto, label = 'Foto desde celular', style, params = {} }) {
  const [abierto, setAbierto] = useState(false);

  const handleResultado = (resultado) => {
    const url = resultado?.resultado?.url;
    if (url && onFoto) onFoto(url);
  };

  return (
    <>
      <button
        type="button"
        title={label}
        onClick={() => setAbierto(true)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '9px 14px',
          borderRadius: '10px',
          border: '1px solid var(--agx-border)',
          background: 'var(--agx-bg)',
          color: 'var(--agx-text)',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: 'inherit',
          ...style,
        }}
      >
        <FiCamera size={16} /> {label}
      </button>
      <BridgeRequestModal
        open={abierto}
        onClose={() => setAbierto(false)}
        tipo="foto"
        titulo="Tomar foto con el celular"
        params={params}
        onResultado={handleResultado}
      />
    </>
  );
}
